import { render, staticRenderFns } from "./SalePageHome.vue?vue&type=template&id=132afe0f&scoped=true&"
import script from "./SalePageHome.vue?vue&type=script&lang=js&"
export * from "./SalePageHome.vue?vue&type=script&lang=js&"
import style0 from "./SalePageHome.vue?vue&type=style&index=0&id=132afe0f&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "132afe0f",
  null
  
)

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VImg } from 'vuetify/lib/components/VImg';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSheet } from 'vuetify/lib/components/VSheet';
installComponents(component, {VBtn,VCol,VIcon,VImg,VRow,VSheet})


/* hot reload */
if (module.hot) {
  var api = require("/opt/build/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('132afe0f')) {
      api.createRecord('132afe0f', component.options)
    } else {
      api.reload('132afe0f', component.options)
    }
    module.hot.accept("./SalePageHome.vue?vue&type=template&id=132afe0f&scoped=true&", function () {
      api.rerender('132afe0f', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/SalePage/components/SalePageHome.vue"
export default component.exports